// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Alopecia (MINOXIDIL) 3.5.2026 09.17.26" (c1c15297-e2cf-4e0d-abce-df309569fa40). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiAlopeciaMinoxidilQuestions = [
  {
    field: 'mdiAlopeciaMinoxidil_typeHairLossExperiencing',
    label: 'What type of hair loss are you experiencing?',
    type: 'select',
    educationalSlide: 'Select all that apply.',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'receding_hairline', value: 'Receding hairline' },
        { key: 'thinning_at_the_crown', value: 'Thinning at the crown' },
        {
          key: 'diffuse_thinning_across_the_scalp',
          value: 'Diffuse thinning across the scalp'
        },
        { key: 'patchy_hair_loss', value: 'Patchy hair loss' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '772b7077-7515-47bd-be3d-1fdb9b9834cf' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_didHairLossBegin',
    label: 'When did your hair loss begin?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_6_months_ago', value: 'Less than 6 months ago' },
        { key: 'o_6_12_months_ago', value: '6–12 months ago' },
        { key: 'o_1_3_years_ago', value: '1–3 years ago' },
        { key: 'more_than_3_years_ago', value: 'More than 3 years ago' }
      ]
    },
    extras: { mdiQuestionId: 'ee99638d-5961-4940-b7ba-400ba250cf5b' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_hairLossGettingWorse',
    label: 'Is your hair loss getting worse?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' },
        { key: 'unsure', value: 'Unsure' }
      ]
    },
    extras: { mdiQuestionId: 'b195deb6-1884-40d8-9e2c-f8a9a423b2a7' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_familyHistoryHairLoss',
    label: 'Do you have a family history of hair loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' },
        { key: 'unsure', value: 'Unsure' }
      ]
    },
    extras: { mdiQuestionId: 'fdd1c7a2-dec7-488a-b945-137be3e185c5' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_whereHairLossLocated',
    label: 'Where is the hair loss located?',
    type: 'select',
    educationalSlide: 'Select all that apply.',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hairline_temples', value: 'Hairline / temples' },
        { key: 'entire_scalp_thinning', value: 'Entire scalp thinning' },
        { key: 'patchy_areas', value: 'Patchy areas' }
      ]
    },
    extras: { mdiQuestionId: '89cb324e-71b3-44ec-85ee-02bddc79f7cd' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_noticed',
    label: 'Have you noticed any of the following?',
    type: 'select',
    educationalSlide: 'Select all that apply.',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'excess_shedding', value: 'Excess shedding' },
        {
          key: 'miniaturized_thinner_hairs',
          value: 'Miniaturized / thinner hairs'
        },
        { key: 'bald_patches', value: 'Bald patches' },
        {
          key: 'itching_or_scalp_irritation',
          value: 'Itching or scalp irritation'
        },
        {
          key: 'i_have_not_noticed_any_of_the_above',
          value: 'I have not noticed any of the above.'
        }
      ]
    },
    extras: { mdiQuestionId: '77ce12d8-0b72-42aa-b927-d3a752801190' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_previouslyUsedHairLossTreatments',
    label: 'Have you previously used hair loss treatments?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_please_specify_which_treatments_you',
          value: 'Yes, (please specify which treatments you have tried).',
          answer: {
            type: 'text',
            name: 'yes_please_specify_which_treatments_you_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'de2dc42f-8f4e-455e-acac-6a294a07b064' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_didTreatmentsHelp',
    label: 'Did the treatments help?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'some_improvement', value: 'Some improvement' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '1a33b46a-40a1-4290-869f-c4505a3b1997' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_ever',
    label: 'Do you currently have or have you ever had:',
    type: 'select',
    educationalSlide: 'Select all that apply.',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'low_blood_pressure', value: 'Low blood pressure' },
        { key: 'heart_disease', value: 'Heart disease' },
        { key: 'heart_rhythm_problems', value: 'Heart rhythm problems' },
        { key: 'congestive_heart_failure', value: 'Congestive heart failure' },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        {
          key: 'fluid_retention_or_swelling',
          value: 'Fluid retention or swelling'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '698f82f0-ade6-4837-9f8b-89ae7b1b415c' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_everDiagnosedHighLowBlood',
    label: 'Have you ever been diagnosed with high or low blood pressure?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes_high_blood_pressure', value: 'Yes – high blood pressure' },
        { key: 'yes_low_blood_pressure', value: 'Yes – low blood pressure' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'ce2c93a8-4b27-4a67-bc13-316d5b0d2963' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_takeMedicationBloodPressure',
    label: 'Do you currently take medication for blood pressure?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_please_list_the_medications',
          value: 'Yes (please list the medications)',
          answer: {
            type: 'text',
            name: 'yes_please_list_the_medications_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '543e0725-6bb2-4074-aff7-a48d08beeec4' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_experiencedRecently',
    label: 'Have you experienced any of the following recently?',
    type: 'select',
    educationalSlide: 'Select all that apply.',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'chest_pain', value: 'Chest pain' },
        { key: 'shortness_of_breath', value: 'Shortness of breath' },
        { key: 'dizziness_or_fainting', value: 'Dizziness or fainting' },
        {
          key: 'rapid_or_irregular_heartbeat',
          value: 'Rapid or irregular heartbeat'
        },
        {
          key: 'swelling_in_the_legs_or_ankles',
          value: 'Swelling in the legs or ankles'
        },
        {
          key: 'no_i_have_not_experienced_any_of_the_fol',
          value: 'No, I have not experienced any of the following recently?'
        }
      ]
    },
    extras: { mdiQuestionId: 'd00cf73a-2a4f-438c-a3ce-f31e1cc5e3ed' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_upload35PhotosScalp',
    label: 'Please upload 3–5 photos of your scalp:',
    type: 'file_upload',
    subLabel:
      '• Front hairline\n• Crown / top of head\n• Both temples\n• Side profile',
    accepts: [
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/png',
      'application/pdf'
    ],
    answer: [
      {
        resourceId: 'mdiAlopeciaMinoxidil_upload35PhotosScalp',
        buttonLabel: 'Upload'
      }
    ],
    extras: { mdiQuestionId: '0a0c698c-f91b-408f-8040-bf11d0f9bed5' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiAlopeciaMinoxidil_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: 'ddfa4c05-9920-4e2f-ab02-88799c10da8b' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Please feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiAlopeciaMinoxidil_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: '737ba7d8-f999-4ff6-9a0f-4b5c9825d325' }
  },
  {
    field: 'mdiAlopeciaMinoxidil_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiAlopeciaMinoxidilAnswerField = Partial<
  QuestionAnswerMap<typeof mdiAlopeciaMinoxidilQuestions>
>;

export default mdiAlopeciaMinoxidilQuestions;
